import React, { useEffect, useState } from "react";
import { Input, NumberInput } from "../plain-inputs";
import { AsyncTypeahead } from "../typeahead";
import classnames from "classnames";
import { Tooltip } from "../../tooltip/tooltip";
import { useSoftValidation } from "../../../shared/hooks/use-soft-validation";

const MeasurementInput = ({ tooltipPosition, ...props }) => {
    const { enableWarning, displayWarning, tooltip, toggleWarning } = useSoftValidation();
    const [measurement, setMeasurement] = useState({
        value: props.defaultValue || props.defaultValue === 0 ? props.defaultValue.value : "",
        uom: props.defaultValue ? props.defaultValue.uom : "",
    });

    useEffect(() => {
        setMeasurement({
            value: props.defaultValue || props.defaultValue === 0 ? props.defaultValue.value : "",
            uom: props.defaultValue ? props.defaultValue.uom : "",
        });
    }, [props.defaultValue]);

    const onUomFieldUpdate = (name, value) => {
        const uom = value ? value : "";
        setMeasurement({
            ...measurement,
            uom,
        });

        reportUp(measurement.value, uom);
    };

    const onInputFieldUpdate = (name, value) => {
        setMeasurement({
            ...measurement,
            value,
        });

        if (displayWarning && enableWarning) {
            toggleWarning(false);
        }

        reportUp(value, measurement.uom);
    };

    const reportUp = (value, uom) => {
        props.updateOnChange(
            props.name,
            {
                value,
                uom,
            },
            props.dataType
        );
    };

    const VariableInput = props.valueAsString ? Input : NumberInput;
    const hasPattern = props.valueAsString ? props.stringPattern : null;
    const id = props.id || props.name;

    return (
        <div className="measurement-input-group">
            <div className={classnames("form-field -small", { "-warning": displayWarning })}>
                <Tooltip
                    asWarning
                    text={displayWarning ? tooltip : undefined}
                    classes="m-r-4"
                    position={tooltipPosition}
                >
                    <VariableInput
                        id={`number_${id}`}
                        value={measurement.value}
                        updateOnChange={onInputFieldUpdate}
                        className="-small"
                        pattern={hasPattern}
                    />
                </Tooltip>
            </div>
            <div className="form-field">
                <AsyncTypeahead
                    id={`uom_${id}`}
                    name={props.name}
                    defaultValue={measurement.uom}
                    updateOnChange={onUomFieldUpdate}
                    tags={props.filter}
                    provider="/picklists/uom/"
                    creatable={true}
                    lengthRestriction={props.lengthRestriction}
                />
            </div>
        </div>
    );
};

MeasurementInput.defaultProps = {
    lengthRestriction: null,
    stringPattern: "^[-+<>]?[0-9]*\\.?[0-9]+$",
    valueAsString: false,
};

export default MeasurementInput;
